var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from "react";
import { Button } from "../buttons";
var TagsButtons = /** @class */ (function (_super) {
    __extends(TagsButtons, _super);
    function TagsButtons() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.getClientHeight = function () {
            if (_this.tagsContainer) {
                return _this.tagsContainer.clientHeight;
            }
            return 0;
        };
        return _this;
    }
    TagsButtons.prototype.render = function () {
        var _this = this;
        return (React.createElement("div", { className: "TagsButtons-grid", ref: function (ref) { return _this.tagsContainer = ref; } }, this.props.buttons.map(function (button, index) {
            return React.createElement(Button, __assign({ key: index }, button));
        })));
    };
    return TagsButtons;
}(React.Component));
;
export default TagsButtons;
//# sourceMappingURL=TagsButtons.js.map